import { Link } from "gatsby"
import { default as React } from "react"
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet
} from "react-instantsearch-dom"
import '../style.scss'
const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits
  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount} result{hitCount !== 1 ? `s` : ``}
    </div>
  ) : (<div>No results</div>)
})

const PageHit = ({ hit }) => {
  const href = hit.slug.split('').map((i, idx) => {
    if (hit.slug.length - 1 === idx) {
      i = '.html'
    }
    return i
  }).join('')

  return (
  <div>
    <Link to={href}>
      <p className='searchResult__title'>
        <Highlight attribute="title" hit={hit} tagName="mark" />
      </p>
    </Link>
    <Snippet attribute="excerpt" hit={hit} tagName="mark" />
  </div>
)}

const HitsInIndex = ({ index }) => {
  return(
  <Index indexName={index.name}>
    <HitCount />
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
)}

const SearchResult = ({ indices, className }) => {

  return(
    <div className={className}>
      {indices.map(index => (
        <HitsInIndex index={index} key={index.name} />
      ))}
    </div>
)}

export default SearchResult